import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import 'js/polyfills';
import 'js/analytics';

import Conductor from 'js/conductor';
import checkFontLoaded from 'js/font-loading';
import mediaLoader from 'js/mediaLoader';
import { replaceIconPlaceholderNodes, triggerJs } from 'js/tools';

import NotificationBar from 'components/molecules/notificationBar_v2/notificationBar_v2';
import Toaster from 'components/molecules/toaster_v2/toaster_v2';
import ContentDialog from 'components/molecules/contentDialog_v2/contentDialog_v2';
import UspBar from 'components/molecules/uspBar_v2/uspBar_v2';
import siteHeader from 'components/siteHeader/siteHeader';

if (window.viabovag?.instrumentationKey) {
    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: window.viabovag.instrumentationKey
        }
    });

    appInsights.loadAppInsights();
    appInsights.trackPageView();
}

checkFontLoaded();

mediaLoader.lazyLoadImages();
mediaLoader.updateImageQualities();

triggerJs('site-header', siteHeader);

const ua = window.navigator.userAgent;
const isIOSSafari = /(iPod|iPhone|iPad)/i.test(ua) && /WebKit/i.test(ua) && !/CriOS/i.test(ua);
const isAndroid = /Android/i.test(ua);

if (isIOSSafari) {
    document.documentElement.classList.add('ua-ios-safari');
}
if (isAndroid) {
    document.documentElement.classList.add('ua-android');
}

const touchSupportClass = 'ontouchstart' in document.documentElement ? 'touch-supported' : 'touch-not-supported';

document.documentElement.classList.add(touchSupportClass);
document.documentElement.classList.remove('transitions-disabled');

window.viabovag = window.viabovag ? window.viabovag : {};

const notificationBar = new NotificationBar();
window.viabovag.showNotification = config => notificationBar.showNotification(config);
window.viabovag.removeNotification = () => notificationBar.removeNotification();

const contentDialog = new ContentDialog();
window.viabovag.showContentDialog = config => contentDialog.showContentDialog(config);
window.viabovag.removeContentDialog = () => contentDialog.removeContentDialog();

const uspBarNode = document.querySelector('[data-js-usp-bar]');
if (uspBarNode) {
    new UspBar(uspBarNode);
}

const toaster = new Toaster();
window.viabovag.showToaster = params => toaster.showToaster(params);
window.viabovag.hideToaster = () => toaster.hideToaster();

if (!window.viabovag.googleRecaptchaSiteKey) {
    window.viabovag.googleRecaptchaSiteKey = '6Le1OY0UAAAAAAcBEi0cXJOXyp7q7li8A_vNed5n';
}

if (!window.viabovag.hasConductor) {
    window.viabovag = {
        ...window.viabovag,
        ...(function iife() {
            const instance = new Conductor();

            return {
                hasConductor: true,
                init: instance.init.bind(instance),
                register: instance.register.bind(instance),
                scan: instance.scan.bind(instance),
                getInstanceById: instance.getInstanceById.bind(instance),
                getInstanceByNode: instance.getInstanceByNode.bind(instance),
                createInstanceByNode: instance.createInstanceByNode.bind(instance),
                deleteInstanceByNode: instance.deleteInstanceByNode.bind(instance)
            };
        })(),
        tools: {
            replaceIconPlaceholderNodes
        }
    };

    window.viabovag.init();
}

window.addEventListener('load', () => {
    window.dispatchEvent(new CustomEvent('app:ready'));
    window.isAppInitialized = true;
});
